import {
  FETCH_MODULES_BEGIN,
  FETCH_MODULES_FULFILLED,
  FETCH_MODULES_REJECTED,
  FETCH_ALL_MODULES_BEGIN,
  FETCH_ALL_MODULES_FULFILLED,
  FETCH_ALL_MODULES_REJECTED,
  FETCH_ALL_MODULES_WITH_COURSES_BEGIN,
  FETCH_ALL_MODULES_WITH_COURSES_FULFILLED,
  FETCH_ALL_MODULES_WITH_COURSES_REJECTED,
  DELETE_MODULES_FULFILLED,
  DELETE_MODULES_REJECTED,
  FETCH_LWNAMES_BEGIN,
  FETCH_LWNAMES_FULFILLED,
  FETCH_LWNAMES_REJECTED,
} from "../actions/moduleActions";

export function moduleReducer(
  state = {
    loading: false,
    result: [],
    modules: [],
    modulesWithCourses: [],
    error: null,
  },
  action
) {
  switch (action.type) {
    case FETCH_MODULES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_MODULES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_MODULES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    }
    case FETCH_ALL_MODULES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_ALL_MODULES_FULFILLED: {
      return {
        ...state,
        loading: false,
        modules: action.payload,
      };
    }
    case FETCH_ALL_MODULES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case FETCH_ALL_MODULES_WITH_COURSES_FULFILLED: {
      return {
        ...state,
        loading: false,
        modulesWithCourses: action.payload,
      };
    }
    case FETCH_ALL_MODULES_WITH_COURSES_BEGIN: {
      return { ...state, loading: true };
    }
    case FETCH_ALL_MODULES_WITH_COURSES_REJECTED: {
      return { ...state, loading: false, error: action.payload };
    }
    case DELETE_MODULES_FULFILLED: {
      return {
        ...state,
        loading: false,
      };
    }
    case DELETE_MODULES_REJECTED: {
      return { ...state, fetching: false, error: action.payload };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
const INIT_LW_FILENAMES = {
  error: null,
  loading: true,
  result: [],
};

export function lwFileNameReducer(state = INIT_LW_FILENAMES, action = {}) {
  switch (action.type) {
    case FETCH_LWNAMES_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case FETCH_LWNAMES_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    }
    case FETCH_LWNAMES_REJECTED: {
      return {
        ...state,
        error: action.payload.error,
        result: [],
      };
    }
    default: {
      return { ...state };
    }
  }
}
